module.exports = __webpack_public_path__ + "assets/img/组 536@2x.9c9b9cce.png";